import * as React from 'react';
import { createComponent } from '@lit/react';
import { TextButtonWC } from './text-button.wc';

export const TextButton = createComponent({
  tagName: TextButtonWC.tagname,
  elementClass: TextButtonWC,
  react: React,
});
